<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2x"><a id="page_v"></a>CONTENTS</h2>
<p class="toc"><em><a href="#/xhtml/acknowledgments#ack">Acknowledgments and Preface</a></em></p>
<p class="toc"><a href="#/xhtml/introduction#int">Introduction</a></p>
<p class="toc1"><span href="#/xhtml/chapter01#ch1" title="Link target outside of Sample">1. The Wicked Major: Embodying Cultural Difference</span></p>
<p class="toc1"><span href="#/xhtml/chapter02#ch2" title="Link target outside of Sample">2. Lance Spearman: The African James Bond</span></p>
<p class="toc1"><span href="#/xhtml/chapter03#ch3" title="Link target outside of Sample">3. Black <em>Titanic:</em> Pirating the White Star Liner</span></p>
<p class="toc1"><span href="#/xhtml/chapter04#ch4" title="Link target outside of Sample">4. Vice and Videos: Kanywood under Duress</span></p>
<p class="toc1"><span href="#/xhtml/chapter05#ch5" title="Link target outside of Sample">5. <em>Dar 2 Lagos:</em> Nollywood in Tanzania</span></p>
<p class="toc1"><span href="#/xhtml/chapter06#ch6" title="Link target outside of Sample">6. Branding bin Laden: The Global “War on Terror” on a Local Stage</span></p>
<p class="toc1"><span href="#/xhtml/chapter07#ch7" title="Link target outside of Sample">7. Master and <em>Mugu:</em> Orientalist Mimicry and Cybercrime</span></p>
<p class="toc1"><span href="#/xhtml/chapter08#ch8" title="Link target outside of Sample">8. “Crazy White Men”: (Un)doing Difference in African Popular Music</span></p>
<p class="toc"><span href="#/xhtml/code#cod" title="Link target outside of Sample">Coda</span></p>
<p class="toc2"><em><span href="#/xhtml/notes#not" title="Link target outside of Sample">Notes</span></em></p>
<p class="toc"><em><span href="#/xhtml/references#ref" title="Link target outside of Sample">References</span></em></p>
<p class="toc"><em><span href="#/xhtml/films#fil" title="Link target outside of Sample">Films</span></em></p>
<p class="toc"><em><span href="#/xhtml/index#ind" title="Link target outside of Sample">Index</span></em></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?2b5101be